import React from "react";
import "./FloatingInstagram.css";
import { data } from "../helper/data";

export default function FloatingInstagram(): React.ReactElement {
  return (
    <div className="floating-instagram">
      <a
        href={data.socialAccounts[0].url}
        target="_blank"
        rel="noreferrer"
        className="instagram-link"
      >
        <img src="/assets/logos/instagram.png" alt="Instagram" />
      </a>
    </div>
  );
}
